import React, { useEffect } from 'react'
import { logoWhite } from '../../utils/images';
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { getMessagesRequest } from '../../store/attachments/actions';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import './style.scss'
import { useParams } from 'react-router-dom';
import PersonIcon from '@material-ui/icons/Person';
import { ReactComponent as MessageAlarm } from "../../assets/images/icons/message_alarm.svg";
import { ReactComponent as MessageChat } from "../../assets/images/icons/message_chat.svg";


function MessagesList({ intl: { messages }, currentDate }) {
    const dispatch = useDispatch();
    const { messagesList } = useSelector((state) => state.attachments);
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            dispatch(getMessagesRequest({ page: 1, patientId: id }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const loadFunc = (page) => {
        dispatch(getMessagesRequest({ page: page, patientId: id }));
    }

     
    if (messagesList) {
        return (
            <div className="scrollbar scrollbar-custom " id="style-4" style={{ height: 280, overflow: 'auto', width: '100%' }} >
                <InfiniteScroll
                        pageStart={1}
                        loadMore={(page) => loadFunc(page)}
                        hasMore={messagesList?.data?.lenght <= messagesList?.total}
                        loader={<div className="loader" key={0}>Loading ...</div>}
                        useWindow={false}
                    >
                        {
                            messagesList?.data?.map((message, i) => (
                                <div key={i} className='message-item'>
                                    <div className='avatar-container'>
                                        {
                                            message?.by_system === 1 ? (
                                                <img src={logoWhite} alt="logo" />
                                            ) : (
                                                <PersonIcon />
                                            )
                                        }
                                    </div>
                                    <div className="message-content">
                                        <span>{moment(message?.created_at).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}</span>
                                        <p>{message.message}</p>
                                    </div>
                                    <div className="message-types">
                                        <MessageAlarm className={message.type === 2 && 'active'} />
                                        <MessageChat className={message.type === 1 && 'active'} />
                                    </div>
                                </div>
                            ))
                        }
                            
                </InfiniteScroll>
            </div>
        )
    } else {
        return (
            <div className="no-data-block">
                {messages.appointments.noMessages}
            </div>
        )
    }
}

export default injectIntl(MessagesList)